import React from 'react';
import './NewsListView.less';
import {Row, Item, Column} from 'react-plan';
import Button from '../../../common/js/app/Button/Button.jsx';
import { Link } from 'react-router';

type Props = {

}

class NewsListView extends React.Component {

  description: 'Showas a list of News.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  componentDidMount() {
    const anchorName = this.props.location.hash;

    if(anchorName) {
      const el = document.getElementById(anchorName.replace('#',''));
      setTimeout(()=> el.scrollIntoView(), 1);
    }
  }
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {

    return (
      <div className="news-list-view">
        <div className="bloc-small m-t-xl m-b-xl">
          <h2 className="m-t-xl m-b-xxl txt-center">News</h2>

          <hr/>
          <Row className="m-b p-t-xl p-b" id="news1">
            <Column className="p-r m-b" size="60%" small="100%">
              { /*<Item className="date">2016.06.18</Item>*/ }
              <h3>WORLD SPACE SCHOOL LAUNCHED</h3>
              <p className="m-t m-b">World Space School opened its doors on Aug, 31, 2016, offering access to a comprehensive program of top-quality space education to students, engineers, managers, administrators, professionals and anyone else eager to learn about space technology.</p>
              <p>The school offers students the choice of a wide range of educational tools, from e-learning and face-to-face lectures to workshops, hands-on tutorials, and more, from big names in the field such as professors Shinichi Nakasuka and Ryosuke Shibasaki.</p>
              <p>World Space School will also offer interactive sessions — by live video or online Q&A — where students can have their own specific questions answered promptly, so that they can overcome obstacles quickly and continue learning.
              </p>
             {/* <Item>
                <Button className="m-t m-b">Read more</Button>
              </Item>*/}
            </Column>
            <Column className="p-l m-b" size="33%" small="100%" align="center">
              <img  className="img-responsive" src={ require('../../../img-layout/news1-thumb.jpg') } />
            </Column>
          </Row>
          <hr/>

          <Row className="m-b p-t-xl p-b" id="news2">
            <Column className="p-r m-b" size="60%" small="100%">
              { /*<Item className="date">2016.06.18</Item>*/ }
              <h3>University of Tokyo Professor Nakasuka gives Spacecraft Design Engineering classes</h3>
              <p className="m-t m-b">Professor Shinichi Nakasuka of the University of Tokyo is providing Spacecraft Design Engineering classes at World Space School. </p>
              <p>The course offers an overview of the issues involved in spacecraft design engineering, covering topics such as "The fundamentals of orbital mechanics," "Thermal design for satellites" and "The fundamentals of spacecraft attitude dynamics and control."</p>
              <p>Professor Nakasuka graduated from the University of Tokyo in 1983, got his Ph.D. in 1988 and went on to work for IBM Research and the University of Tokyo's Department of Aeronautics and Astronautics, becoming a professor there in 2004.  He has developed and succesfully launched seven micro-satellites. </p>
              <p>Nakasuka chairs the IFAC Aerospace Technical Committee and UNISEC-Global, and is a member of JSASS, SICE, and IAA. He has been a member of Space Policy Committee of Cabinet Office of Japan since 2012. </p>
              {/*<Item>
                <Button className="m-t m-b">Read more</Button>
              </Item>*/}
            </Column>
            <Column className="p-l m-b" size="33%" small="100%" align="center">
              <img  className="img-responsive" src={ require('../../../img-layout/news2-thumb.jpg') } />
            </Column>
          </Row>
          <hr/>

          <Row className="m-b p-t-xl p-b" id="news3">
            <Column className="p-r m-b" size="60%" small="100%">
              { /*<Item className="date">2016.06.18</Item>*/ }
              <h3>Astronaut Naoko Yamazaki to offer lessons from space mission</h3>
              <p className="m-t m-b">Astronaut Naoko Yamazaki will be giving classes as part of the Spacecraft Design Engineering course at World Space School. Topics in this course include "An introduction to the International Space Station (ISS) and its activities" and "Space exploration and international cooperation.”</p>
              <p>After earning her bachelor's and master's degrees in Aerospace Engineering at the University of Tokyo, Yamazaki started working for Japan Aerospace Exploration Agency (JAXA) — then known as NASDA — in 1996.</p>
              <p>Three years later she was selected as an astronaut candidate by JAXA, and by 2001 she was certified as an astronaut. In 2004, Yamazaki completed Soyuz-TMA Flight Engineer training at the Yuri Gagarin Cosmonaut Training Center in Star City, Russia, and two years after that she was certified as a Mission Specialist by NASA.</p>
              <p>On April 5, 2010, Yamazaki joined the crew of the Space Shuttle Discovery as a mission specialist on an assembly and resupply mission to the ISS. She returned to Earth on April 20, 2010.</p>
              <p>Yamazaki retired from JAXA the following year and has been serving as a member of the Japan Space Policy Committee ever since. She is also an adviser to the Young Astronaut Club (YAC) and a visiting professor at Ritsumeikan University and the Joshibi University of Art and Design.</p>
              {/*<Item>
                <Button className="m-t m-b">Read more</Button>
              </Item>*/}
            </Column>
            <Column className="p-l m-b" size="33%" small="100%" align="center">
              <img  className="img-responsive" src={ require('../../../img-layout/news3-thumb.jpg') } />
            </Column>
          </Row>


          {/*<Row className=" p-t " >
            <Column className="p-r m-b" size="20%" small="100%" align="center">
              <img  className="img-responsive" src={ require('../../../img-layout/earth-thumb.jpg') } />
            </Column>
            <Column className="p-l m-b" size="80%" small="100%">
              <Item className="date">2016.06.18</Item>
              <h3>Title News</h3>
              <p className="m-t m-b">Lorem excepteur anim ut cillum tempor mollit occaecat dolore esse.Sunt non occaecat qui mollit do aliqua cupidatat deserunt nulla in reprehenderit.Consequat ea ea enim eu pariatur ipsum veniam veniam.Dolore aute culpa veniam officia.Mollit aliqua sunt ullamco duis enim qui velit dolor....<Link to="/newsdetails">read more</Link>
              </p>

            </Column>

          </Row>*/}


        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default NewsListView;

//Unit test entry point
export const NewsListViewTest = NewsListView;


/** WEBPACK FOOTER **
 ** ./src/js/views/NewsListView/NewsListView.jsx
 **/